import { createFileRoute } from "@tanstack/react-router";
import { guardWorkspaceAccess } from "@/lib/workspaceGuard";
import { guardUpdatesStep } from "@/lib/onboardingGuard";
import { OnboardingAuthGate } from "@/components/onboarding/OnboardingAuthGate";
import { OnboardingUpdates } from "@/components/onboarding/OnboardingUpdates";
import { useOnboardingStepEvent } from "@/lib/useOnboardingStepEvent";

// Screen 3: consent to GoodSender's own product mail. Informational and
// skippable — consent itself moves via the approve link in the email. Shown
// only for the account's registration workspace (spec 1136); access control
// runs first so a signed-out/non-member visitor gets today's redirect, not
// `guardUpdatesStep`'s first-post one.
export const Route = createFileRoute("/onboarding/$workspaceId/updates")({
  ssr: false,
  beforeLoad: async (opts) => {
    await guardWorkspaceAccess(opts);
    await guardUpdatesStep(opts);
  },
  component: OnboardingUpdatesRoute,
});

function OnboardingUpdatesRoute() {
  useOnboardingStepEvent("updates");
  const { workspaceId } = Route.useParams();
  return (
    <OnboardingAuthGate>
      <OnboardingUpdates workspaceId={workspaceId} />
    </OnboardingAuthGate>
  );
}
